import { deepComparison } from "client/Misc/compareUtils";
import {
	RefObject,
	useEffect,
	useRef,
	useState
} from "react";

export function useDeepComparison<TValue>(deps: TValue): number {
	const previousValue: RefObject<TValue | undefined> = useRef<TValue>(undefined);
	const [version, setVersion] = useState<number>(0);

	useEffect(
		() => {
			if (!deepComparison(deps, previousValue.current)) {
				setVersion(version => version + 1);
			}

			previousValue.current = deps;
		},
		[deps]
	);

	return version;
}